import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT, UserProperty } from '@ld.consumer-portal/models';
import { firstValueFrom } from 'rxjs';

export enum ContactInformationEnum {
  LastUpdatedContactMgmt = 'LastUpdatedContactMgmt',
  User = 'User',
}

@Injectable({ providedIn: 'root' })
export class ServicingUserProfileService {
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENVIRONMENT);

  private get baseUrl(): string {
    return this.env.appSettings.profileDomainUrl || '';
  }

  private get apiNamespace(): string {
    return this.env.appSettings.apiNamespace || 'api/v1';
  }

  async upsertUserProperty(userId: string, userProperty: UserProperty): Promise<boolean> {
    const url = `${this.baseUrl}/${this.apiNamespace}/LDProfileDomain/UserProfile/UpsertUserProperty`;
    const params = { userId };

    return firstValueFrom(this.http.post<boolean>(url, userProperty, { params }));
  }

  createLastUpdatedContactMgmtProperty(): UserProperty {
    const now = new Date().toISOString();
    return {
      key: ContactInformationEnum.LastUpdatedContactMgmt,
      value: now,
      originalValue: now,
      collectionName: ContactInformationEnum.User,
    };
  }

  async updateLastContactMgmtTimestamp(userId: string): Promise<boolean> {
    const property = this.createLastUpdatedContactMgmtProperty();
    return this.upsertUserProperty(userId, property);
  }
}
